/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Broker_Photo_HintInputs */

const cs_draft_broker_photo_hint = /** @type {(inputs: Draft_Broker_Photo_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bere se z veřejného profilu přiřazeného makléře. Nejde o fotografii z galerie inzerátu.`)
};

const en_draft_broker_photo_hint = /** @type {(inputs: Draft_Broker_Photo_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taken from the assigned broker’s public profile avatar. Not a property gallery photo.`)
};

/**
* | output |
* | --- |
* | "Taken from the assigned broker’s public profile avatar. Not a property gallery photo." |
*
* @param {Draft_Broker_Photo_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_broker_photo_hint = /** @type {((inputs?: Draft_Broker_Photo_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Broker_Photo_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_broker_photo_hint(inputs)
	return cs_draft_broker_photo_hint(inputs)
});